export function arrayToggle<T>(array: T[], value: T): T[] {
  const newArray = [...array];

  if (value) {
    // if value is set, either remove it from the list - or add it.
    const iof = newArray.indexOf(value);
    if (iof !== -1) {
      newArray.splice(iof, 1);
    } else {
      newArray.push(value);
    }
  }

  return newArray;
}
